import React from "react";
import PropTypes from "prop-types";

const SEO = ({ title }) => {
  return (
    <>
      <meta charSet="utf-8" />
      <title>SmartFy | {title}</title>
      <meta name="robots" content="noindex, follow" />
      <meta
        name="description"
        content="Améliorez l'expérience de vos clients et équipez votre restaurant d'un menu digital avec QR code. Donnez leur accès en un rien de temps à votre carte."
      />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
    </>
  );
};
SEO.propTypes = {
  title: PropTypes.string,
};

export default SEO;
